import { render } from "./TeacherApplicationsModal.vue?vue&type=template&id=39cfeeaa"
import script from "./TeacherApplicationsModal.vue?vue&type=script&lang=js"
export * from "./TeacherApplicationsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__